<style lang="scss">
//滚动条的滑块
.monitorEfficiency::-webkit-scrollbar-thumb {
	background-color: #419FFF;
	border-radius: 2px;
}
</style>

<template>
	<div ref="container" class="monitorEfficiency" style="overflow: auto;height: 100%;position: relative;padding: 20px;">
		<div ref="titleBar" class="titleBar" style="display: flex;align-items:center ;padding-bottom: 10px;justify-content: space-between;">
			<div style="display: flex;align-items: center;">
				<span style="width: 5px;height: 16px;background: #419FFF;margin-right:12px ;"></span>
				<p style="font-size: 16px;line-height: 22px;color: #F4F4F4;">
					{{ $t('liangtaijijihuakaijishijian') }}
				</p>
			</div>

		</div>
		<div id="xiangjiaoMonitorJihuakaijichart" :style="{ 'height': chartHeight + 'px' }">


		</div>

	</div>

</template>
<script type="text/javascript">
export default {
	name: 'web_monitor_efficiency_all',
	components: {

	},
	props: {
		datas: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			timer: null,
			chart: null,
			option: null,
			chartHeight: 0,
		};
	},
	created() {
		this.timer = setInterval(() => {
			this.makeData()
		}, 600000)
	},

	watch: {
		datas: {
			handler(n, o) {
				if (n != o) {
					this.makeData()
				}
			},
			deep: true
		}
	},
	activated() {
		this.resize()
	},
	mounted() {
		this.resize()
		this.utils.event_hub.$on('RESIZE', () => {
			this.resize();
		});
		this.makeData()

	},


	destroyed() {
		if (this.timer) {
			clearInterval(this.timer)
		}
	},
	methods: {
		makeData() {
			this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
				20
			if (!this.chart) {
				setTimeout(() => {
					this.initChart()
					this.makeData()
				}, 100)
			} else {



				let dates = Object.keys(this.datas["YL2-H300F"].runTimeRateMap)
				//dates年月日从小到大排序
				dates.sort((a, b) => {
					let aDate = new Date(a)
					let bDate = new Date(b)
					return aDate - bDate
				})
				let kaijishijian1 = []
				let kaijishijian2 = []


				dates.forEach(item => {
					kaijishijian1.push(9)
					kaijishijian2.push(9)
				})
				//只取日
				dates = dates.map(item => {
					let d = item.split("-")[2]
					if (d[0] == '0') {
						return d[1] + this.$t('ri')
					} else {
						return d + this.$t('ri')
					}
				})



				this.option.xAxis.data = dates;
				this.option.series[0].data = kaijishijian1;
				this.option.series[1].data = kaijishijian2;
				this.chart.setOption(this.option)
			}

		},
		resize() {
			//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
			setTimeout(() => {
				if (!this.$refs.titleBar) {
					return;
				}
				this.chartHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 20 -
					20
				if (!this.chart) {
					return;
				}
				this.chart.getDom().style.height = this.chartHeight + "px";
				this.chart.resize()

			}, 800)
		},
		initChart() {
			this.option = {
				backgroundColor: null,
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						label: {
							formatter: '{value} '
						},
						// 坐标轴指示器，坐标轴触发有效
						type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
					},
					backgroundColor: 'rgba(0,0,0,0.8)',
					borderWidth: 0,
					textStyle: {
						color: "#C0C4CC",
					},
					valueFormatter: (value) => {
						return value
					}
				},
				grid: {
					left: '0',
					right: '0',
					bottom: '0',
					top: '30',
					containLabel: true,
				},
				legend: {
					left: 'center',
					top: '0%',
					textStyle: {
						color: '#FFFFFF',
						fontSize: 12,
					},
					itemWidth: 15,
					itemHeight: 10,
					itemGap: 25,
				},
				dataZoom: [{
					show: false,
					height: 8,
					xAxisIndex: [0],
					bottom: 0,
					start: 0,
					end: 100,
					handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
					handleSize: '100%',
					handleStyle: {
						color: 'rgba(255, 255, 255,1',
					},
					textStyle: {
						color: "transparent",
						fontSize: 12,
					},
					fillerColor: '#CBCED4',
					borderColor: 'transparent',
					backgroundColor: 'transparent',
					showDataShadow: false,
					brushSelect: false,
				},
				{
					type: 'inside',
					disabled: false,
				},
				],
				xAxis: {
					show: true,
					type: 'category',
					name: '',
					nameLocation: 'end',
					nameTextStyle: {
						fontSize: 12,
					},
					inverse: false,
					splitLine: {
						show: false,
						lineStyle: {
							type: 'dashed',
							color: '#000',
							width: 1,
						},
					},
					axisTick: {
						show: true,
						alignWithLabel: false,
						interval: 'auto',
						inside: false,
						length: 5,
						lineStyle: {
							type: 'solid',
							width: 1,
							color: '#909399',
						},
					},
					axisLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							width: 1,
							color: '#909399',
						},
					},
					axisLabel: {
						margin: 8,
						interval: 'auto',
						rotate: 0,
						fontSize: 12,
						color: '#C0C4CC',
					},
					data: [],
				},
				yAxis: [{
					show: true,
					type: 'value',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value}',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}, {
					show: true,
					type: 'value',
					position: 'right',
					name: '',
					min: 0,
					nameTextStyle: {
						color: '#909399',
					},
					axisLine: {
						show: false,
						lineStyle: {
							color: '#909399',
						},
					},
					axisTick: {
						show: false,
					},
					axisLabel: {
						formatter: '{value} %',
						rotate: 0,
						textStyle: {
							color: '#C0C4CC',
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: '#606672',
						},
					},
				}],
				series: [{
					name: this.$t('YL2-H300F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#FD9DFF',
							},
							{
								offset: 1,
								color: '#4F32FF',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#5C41FF',
						position: 'top',
						fontSize: 12,
						labelFormatter: '{data} %'
					},
					// data: this.efficiencies.runRates,
					data: [],

				},
				{
					name: this.$t('YL3-V440F'),
					type: 'bar',
					barWidth: '12px',
					itemStyle: {
						normal: {
							color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#6FE5FF',
							},
							{
								offset: 1,
								color: '#1C70C6',
							},
							]),
							barBorderRadius: 6,
						},
					},
					label: {
						show: false,
						rotate: 0,
						color: '#419FFF',
						position: 'top',
						fontSize: 12,
					},
					// data: this.efficiencies.runTimeRates,
					data: [],
					// runRate

				}
				],


			};
			var chartDom = document.getElementById('xiangjiaoMonitorJihuakaijichart');
			this.chart = this.echarts.init(chartDom);
			this.option && this.chart.setOption(this.option);
		}
	}
};
</script>
